import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/concatMap'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/from'
import 'rxjs/add/observable/zip'
import 'rxjs/add/observable/never'
import 'rxjs/add/observable/empty'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import { TimestampTypes } from './timestampRedux'
import { LayerTypes } from './layerRedux'
import { TimeSliderTypes } from './timeSliderRedux'
import { ServiceTypes } from './serviceRedux'
import { getViewparams } from '../selectors/viewparamsSelector'
import { makeGetShouldFetchDatetime } from '../selectors/shouldFetchDatetimes'
import convertToDatetime from '../utility/convertToDatetime'
import getFutureDate from '../utility/getFutureDate'
import createBbox from '@turf/bbox'
import convertBoundsToMercatorBoundingBox from '../utility/convertBoundsToMercatorBoundingBox'
import convertToMercator from '../utility/convertToMercator'
import { getGeneratedMarks } from '../selectors/generatedMarksSelector'
import sentinelFilter from '../utility/sentinelFilter'
import { getMinMaxDateFromTimeIso } from '../utility/getDateFromTimeIso'
import createDateAsUTC from '../utility/createDateAsUTC'
import convertDateToUTC from '../utility/convertDateToUTC'
import { ICE_DRIFT_BRAND } from '../config/services'

const TIMESTAMP_UPDATE_REQUESTED = TimestampTypes.TIMESTAMP_UPDATE_REQUESTED
const TIMESTAMP_UPDATE_FULFILLED = TimestampTypes.TIMESTAMP_UPDATE_FULFILLED
const TIME_SLIDER_MARKS_UPDATED = TimeSliderTypes.TIME_SLIDER_MARKS_UPDATED
const TIME_SLIDER_SEASON_UPDATED = TimeSliderTypes.TIME_SLIDER_SEASON_UPDATED
// const TIMESTAMP_UPDATE_FAILED = TimestampTypes.TIMESTAMP_UPDATE_FAILED
const BOUNDS_CHANGED = TimestampTypes.BOUNDS_CHANGED
const LAYER_DEFAULT_TIME_UPDATED = LayerTypes.LAYER_DEFAULT_TIME_UPDATED
const LAYER_RENDER_TOGGLED = LayerTypes.LAYER_RENDER_TOGGLED
const LAYER_TIME_UPDATED = LayerTypes.LAYER_TIME_UPDATED
const SERVICE_CARD_CHANGED = ServiceTypes.seRVICE_CARD_CHANGED
const SEASON_INCREMENTED = TimestampTypes.SEASON_INCREMENTED
const SEASON_DECREMENTED = TimestampTypes.SEASON_DECREMENTED

const getShouldFetchDatetime = makeGetShouldFetchDatetime()
// const ICE_DRIFT_DATE = '2019-04-23'
const ICE_DRIFT_DATE = new Date()
const ARCTIC_DATE = '2018-07-02'
const PIPELINE_DATE = '2018-09-30'

const timestampUpdateFulfilled = (layerName, json, accessor) => ({
  type: TIMESTAMP_UPDATE_FULFILLED,
  layerName,
  json,
  accessor
})

const layerDefaultTimeUpdated = (layerName, json, accessor) => ({
  type: LAYER_DEFAULT_TIME_UPDATED,
  layerName,
  json,
  accessor
})

const datetimeUrls = [
  {
    id: 'CatalogItems',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:CatalogItems&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => {
      const timestamps = json.features.map(feature => feature.properties.timestamp)
            .filter(timestamp => timestamp)
      console.log(timestamps)
      return timestamps
    }
  },
  {
    id: 'SmartIce',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:SmartIceMapsAreaBounds&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: ICE_DRIFT_BRAND ? json => {
      const timestamps = json.features.map(feature => feature.properties.timestamp)
            .filter(timestamp => timestamp)
      return (timestamps)
    } : undefined
  },
  {
    id: 'SmartIceQamutik',
    authId: 'SmartIce',
    url:
      'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:SmartIceQamutikAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'SmartIceQamutikLineString',
    authId: 'SmartIce',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:SmartIceQamutikLineStringTime&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => json.features.map(feature => {
      const date = feature.properties.timestamp
      const minDate = getMinMaxDateFromTimeIso({ timeIso: date, min: true })
      return minDate
    })
  },
  {
    id: 'MopraWellsites',
    authId: 'ReclaimedWellsites',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:ReclaimedWellsitesAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'Mopra',
    authId: 'ReclaimedWellsites',
    url:
      'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:ReclaimedWellsitesAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'LandDeformationInsar',
    authId: 'LandDeformation',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:LandDeformationCaliforniaTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'RiverIce',
    type: 'feathers',
    url:
    'https://feathers.looknorthservices.com/features',
    accessor: json => [new Date('2019-04-15T13:27:37Z').toISOString(), new Date('2019-04-09T01:03:03Z').toISOString(), new Date('2019-04-08T13:36:49Z').toISOString(), new Date('2019-04-01T13:40:53Z').toISOString(), new Date('2019-03-29T01:23:26Z').toISOString(), new Date('2019-03-26T01:11:10Z').toISOString(), new Date('2019-03-22T13:32:33Z').toISOString(), new Date('2019-03-15T02:32:02Z').toISOString(), new Date('2019-03-09T01:07:06Z').toISOString()],
  },
  {
    id: 'RiverIceChurchill',
    authId: 'RiverIce',
    url:
    `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ARiverIceAreaSummary&propertyName=date,timestamp`,
    accessor: json => json.features.map(feature => {
      const ts = new Date(feature.properties.timestamp).toISOString()
      
      return ts
    })
  },
  {
    id: 'PipelineGreen',
    authId: 'Pipeline',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:PipelineGreenTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'PipelineGreenEn2',
    authId: 'Pipeline',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:PipelineGreenEn2Time&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'PipelineGreenBase',
    authId: 'Pipeline',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:PipelineGreenTime&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => json.features.map(feature => feature.properties.timestamp_2)
  },
  {
    id: 'PipelineChangeDetection',
    authId: 'PipelineChangeDetection',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:PipelineChangeDetectionTime&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => json.features.map(feature => feature.properties.timestamp_2)
  },
  {
    id: 'IceDrift',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:IceDriftTime&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => {
      const timestamps = json.features.map(feature => feature.properties.timestamp)
            .filter(timestamp => timestamp >= '2018-05-01')

      return (timestamps)
    }
  }
  ,
  {
    id: 'IceDriftVelocity',
    authId: 'IceDrift',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:IceDriftVelocityTime&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => {
      const timestamps = json.features.map(feature => feature.properties.timestamp)
            //.filter(timestamp => timestamp < '2018-05-23T12:09:07.516Z')
      return (timestamps)
    }
  },
  {
    id: 'IceDriftDisplacement',
    authId: 'IceDrift',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:IceDriftFeatureTrackingTime&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => {
        const timestamps = json.features.map(feature => feature.properties.timestamp)
              .filter(timestamp => timestamp >= '2018-05-01')

        return (timestamps)
    }
  },
  {
    id: 'IceDriftDeformation',
    authId: 'IceDrift',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:IceDriftDeformationTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'IceDriftDeformationShear',
    authId: 'IceDrift',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:IceDriftDeformationTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'IceDriftDeformationVorticity',
    authId: 'IceDrift',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:IceDriftDeformationTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'IceDriftDirection',
    authId: 'IceDrift',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:IceDriftDirectionTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'IceDriftMagnitude',
    authId: 'IceDrift',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:IceDriftMagnitudeTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'BathymetryFft',
    authId: 'Bathymetry',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:BathymetryFftTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'BathymetryWavelet',
    authId: 'Bathymetry',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:BathymetryWaveletTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'WaterTemperature',
    url:
      'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WaterTemperatureAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'WaterSediment',
    url:
      'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WaterSedimentAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'WaterRiverSsc',
    url:
      'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WaterRiverSscTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'WaterLakeTss',
    url:
      'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WaterLakeTssTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'WaterLakeChl',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WaterLakeChlTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'WellsiteNdviLease',
    authId: 'ReclaimedWellsites',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WellsiteNdviTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'WellsiteNdviControl',
    authId: 'ReclaimedWellsites',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WellsiteNdviTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'WellsiteEviLease',
    authId: 'ReclaimedWellsites',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WellsiteEviTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'WellsiteEviControl',
    authId: 'ReclaimedWellsites',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WellsiteEviTime&maxFeatures=500&outputFormat=application%2Fjson'
  },
  {
    id: 'Sentinel2Ndvi',
    authId: 'ReclaimedWellsites',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WellsiteNdviTime&maxFeatures=500&outputFormat=application%2Fjson',
    secondary: true,
    // type: 'global'
  },
  {
    id: 'RiverFloodMonitoring',
    authId: 'RiverFloodMonitoring',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:FloodMonitoringTime&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => [new Date('2018-04-21 15:59:09').toISOString(), new Date('2018-04-22 15:59:09').toISOString(), new Date('2018-04-23 15:59:09').toISOString(), new Date('2018-04-24 15:59:09').toISOString(), new Date('2018-04-25 15:59:09').toISOString(), new Date('2018-04-26 15:59:09').toISOString()],
  },
  {
    id: 'Energir',
    authId: 'Energir',
    type: 'feathers',
    url:
    'https://feathers.looknorthservices.com/features',
    accessor: json => [new Date('2019-08-10').toISOString(), new Date('2019-08-03').toISOString(), new Date('2019-07-27').toISOString(), new Date('2019-07-20').toISOString(), new Date('2019-07-13').toISOString(), new Date('2019-07-06').toISOString(), new Date('2019-06-29').toISOString(), new Date('2019-06-22').toISOString(), new Date('2019-06-15').toISOString(), new Date('2019-06-08').toISOString(), new Date('2019-06-01').toISOString(), new Date('2019-05-25').toISOString(), new Date('2019-05-18').toISOString(), new Date('2019-05-11').toISOString(), new Date('2019-05-04').toISOString(), new Date('2019-04-27').toISOString(), new Date('2019-04-20').toISOString(), new Date('2019-04-13').toISOString(), new Date('2019-04-06').toISOString(), new Date('2019-03-30').toISOString(), new Date('2019-03-23').toISOString(), new Date('2019-03-16').toISOString(), new Date('2019-03-09').toISOString(), new Date('2019-03-03').toISOString(), new Date('2019-02-24').toISOString(), new Date('2019-02-17').toISOString(), new Date('2019-02-02').toISOString(), new Date('2018-07-14').toISOString()],
  },
  {
    id: 'Petrobras',
    authId: 'Petrobras',
    type: 'feathers',
    url:
    'https://feathers.looknorthservices.com/features',
    accessor: json => [new Date('2019-02-24').toISOString(), new Date('2019-03-06').toISOString(), new Date('2019-03-16').toISOString()],
  },
  // {
  //   id: 'RiverIceChurchill',
  //   authId: 'RiverIce',
  //   url:
  //   'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:RiverIceAreaBounds&maxFeatures=500&outputFormat=application%2Fjson',
  //   accessor: json => [new Date('2018-04-21 15:59:09').toISOString(), new Date('2018-04-22 15:59:09').toISOString(), new Date('2018-04-23 15:59:09').toISOString(), new Date('2018-04-24 15:59:09').toISOString(), new Date('2018-04-25 15:59:09').toISOString(), new Date('2018-04-26 15:59:09').toISOString()],
  // },
  {
    id: 'FloodHazard',
    authId: 'FloodMonitoring',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:FloodMonitoringTime&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => [new Date('2017-02-15 15:59:09').toISOString(), new Date('2018-04-03 15:59:09').toISOString()],
  },
  // {
  //   id: 'Sentinel1',
  //   authId: 'Sentinel',
  //   url:
  //     'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
  //   type: 'bbox',
  //   accessor: json => json.features.map(feature => feature.properties.date)
  // },
  {
    id: 'Sentinel1',
    authId: 'Sentinel',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'bbox',
    secondary: true,
    accessor: json => sentinelFilter(json)
  },
  {
    id: 'Sentinel1SmartIce',
    authId: 'Sentinel',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS&TIME=2017-02-21/2017-06-27/P1D',
    type: 'bbox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date)
  },
  // {
  //   id: 'Sentinel2',
  //   authId: 'Sentinel',
  //   url:
  //     'https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
  //   type: 'bbox',
  //   accessor: json => json.features.map(feature => feature.properties.date)
  // },
  {
    id: 'Sentinel2',
    authId: 'Sentinel',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'bbox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date).filter(date => date >= format(subDays(new Date(), 30), 'yyyy-MM-dd'))
  },
  {
    id: 'Sentinel2ThreeMonth',
    authId: 'Sentinel',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'bbox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date).filter(date => date >= format(subDays(new Date(), 90), 'yyyy-MM-dd'))
  },
  {
    id: 'Sentinel2SixMonth',
    authId: 'Sentinel',
    url:
    `https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS`,
    type: 'smallBox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date)
  },
  {
    id: 'Sentinel1SixMonth',
    authId: 'Sentinel',
    url:
    `https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS`,
    type: 'smallBox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date)
  },
  {
    id: 'Sentinel1IceDrift',
    authId: 'Sentinel',
    url:
    `https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS&TIME=${format(subDays(new Date(ICE_DRIFT_DATE), 180), 'yyyy-MM-dd')}/${format(new Date(ICE_DRIFT_DATE), 'yyyy-MM-dd')}/P1D`,
    type: 'bbox',
    secondary: true,
    accessor: json => {
      const dates = ['2018-04-04', '2018-04-05', ...json.features.map(feature => feature.properties.date)]

      return dates
    }
  },
  {
    id: 'Sentinel1Arctic',
    authId: 'Sentinel',
    url:
    `https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS&TIME=${format(subDays(new Date(ARCTIC_DATE), 90), 'yyyy-MM-dd')}/${format(new Date(ARCTIC_DATE), 'yyyy-MM-dd')}/P1D`,
    type: 'bbox',
    secondary: true,
    accessor: json => {
      const dates = [...json.features.map(feature => feature.properties.date)]
      return dates
    }
  },
  {
    id: 'Sentinel2Arctic',
    authId: 'Sentinel',
    url:
    `https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS&TIME=${format(subDays(new Date(ARCTIC_DATE), 90), 'yyyy-MM-dd')}/${format(new Date(ARCTIC_DATE), 'yyyy-MM-dd')}/P1D`,
    type: 'bbox',
    secondary: true,
    accessor: json => {
      const dates = [...json.features.map(feature => feature.properties.date)]
      // const dates = [...json.features.map(feature => feature.properties.date)]

      return dates
      // return []
    }
  },
  {
    id: 'PlanetMosaic',
    authId: 'Sentinel',
    url:
    `https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS&TIME=${format(subDays(new Date(ARCTIC_DATE), 90), 'yyyy-MM-dd')}/${format(new Date(ARCTIC_DATE), 'yyyy-MM-dd')}/P1D`,
    type: 'bbox',
    secondary: true,
    accessor: json => {
      const dates = [new Date('2018-04-01 15:59:09').toISOString(), new Date('2018-05-01 15:59:09').toISOString(), new Date('2018-06-01 15:59:09').toISOString(), new Date('2018-07-01 15:59:09').toISOString(), new Date('2018-08-01 15:59:09').toISOString(), new Date('2018-09-01 15:59:09').toISOString()]

      return dates
      // return []
    }
  },
    {
    id: 'Sentinel1Pipeline',
    authId: 'Sentinel',
    url:
    `https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS&TIME=${format(subDays(new Date(PIPELINE_DATE), 90), 'yyyy-MM-dd')}/${format(new Date(PIPELINE_DATE), 'yyyy-MM-dd')}/P1D`,
    type: 'bbox',
    secondary: true,
    accessor: json => {
      const dates = [...json.features.map(feature => feature.properties.date)]
      return dates
    }
  },
  {
    id: 'Sentinel2Pipeline',
    authId: 'Sentinel',
    url:
    `https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS&TIME=${format(subDays(new Date(PIPELINE_DATE), 90), 'yyyy-MM-dd')}/${format(new Date(PIPELINE_DATE), 'yyyy-MM-dd')}/P1D`,
    type: 'bbox',
    secondary: true,
    accessor: json => {
      const dates = [...json.features.map(feature => feature.properties.date)]

      return dates
      // return []
    }

  },
  {
    id: 'Sentinel2LeakDetection',
    authId: 'Sentinel',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'bbox',
    secondary: true,
    accessor: json => [new Date('2018-02-01 15:59:09').toISOString(), new Date('2018-02-08 15:59:09').toISOString(), new Date('2018-02-15 15:59:09').toISOString(), new Date('2018-02-22 15:59:09').toISOString(), new Date('2018-02-29 15:59:09').toISOString()],
  },
  {
    id: 'WellsiteRank',
    authId: 'ReclaimedWellsites',
    url:
    'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:WellsiteRankDate&maxFeatures=500&outputFormat=application%2Fjson',
    accessor: json => json.features.map(feature => {
      const date = feature.properties.date
      const maxDate = getMinMaxDateFromTimeIso({ timeIso: date, max: true })
      return maxDate
    })
  },
  // {
  //   id: 'WellsiteRank',
  //   authId: 'LeakDetection',
  //   url:
  //   'https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=10&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
  //   type: 'bbox',
  //   accessor: json => [new Date('2017-08-27 18:29:09.027000+00:00').toISOString(), new Date('2017-08-12 18:29:21.026000+00:00').toISOString()],
  // },
  {
    id: 'LeakDetection',
    authId: 'LeakDetection',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=10&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'bbox',
    accessor: json => [new Date('2018-02-22 15:59:09').toISOString(), new Date('2018-02-15 15:59:09').toISOString()],
  },
  {
    id: 'ArcticCrowdSource',
    authId: 'ArcticCrowdSource',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/f41940fe-94cf-4d4c-b449-e532dca14441?version=2.0.0&request=GetFeature&typeNames=S2.TILE&maxFeatures=10&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'bbox',
    accessor: json => [new Date('2018-05-29 15:59:09').toISOString()],
  },
  // {
  //   id: 'Modis',
  //   authId: 'Sentinel',
  //   url:
  //     'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
  //   type: 'bbox',
  //   accessor: json => json.features.map(feature => feature.properties.date)
  // },
  {
    id: 'Modis',
    authId: 'Sentinel',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'smallBox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date).filter(date => date >= format(subDays(new Date(), 30), 'yyyy-MM-dd'))
  },
  {
    id: 'ModisIceDrift',
    authId: 'Sentinel',
    url:
    `https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS`,
    type: 'smallBox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date)
  },
  {
    id: 'CmemsSeaIce',
    authId: 'Sentinel',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'bbox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date).sort().filter((date, index, { length }) => length - 1 === index)
  },
  {
    id: 'CmemsSnowThickness',
    authId: 'Sentinel',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'bbox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date).sort().filter((date, index, { length }) => length - 1 === index)
  },
  {
    id: 'CmemsSurfaceTemperature',
    authId: 'Sentinel',
    url:
    'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A3857&service=WFS',
    type: 'bbox',
    secondary: true,
    accessor: json => json.features.map(feature => feature.properties.date).sort().filter((date, index, { length }) => length - 1 === index)
  },
]

const formatDatetimeUrl = (url, viewparams, idToken) => {
  return `${url}&viewparams=${viewparams}&token=${idToken}`
}

const formatGlobalUrl = (url, viewparams, idToken) => {
  return `${url}&token=${idToken}`
}

const formatBboxUrl = (url, bounds, datetime, center) => {
  const mercatorBbox = convertBoundsToMercatorBoundingBox(bounds)

  const _bbox = `${mercatorBbox[0][0]},${mercatorBbox[0][1]},${
    mercatorBbox[1][0]
  },${mercatorBbox[1][1]}`

  return `${url}&bbox=${_bbox}`
}

const formatSmallBoxUrl = (url, bounds, datetime, center, timeIso) => {

  const date = !timeIso || timeIso === 'NaN' ? new Date(ICE_DRIFT_DATE) : new Date(timeIso)

  const geometry = {
    type: 'Point',
    coordinates: [center.lng, center.lat]
  }
  const newBounds = { _ne: { lng: center.lng, lat: center.lat }, _sw: { lng: center.lng-0.01, lat: center.lat-0.01 }}

  const mercatorBbox = convertBoundsToMercatorBoundingBox(newBounds)
  const _bbox = `${mercatorBbox[0][0]},${mercatorBbox[0][1]},${
    mercatorBbox[1][0]
  },${mercatorBbox[1][1]}`
  

  const centerBbox = createBbox(geometry).map(item => convertToMercator(item))

  const bbox = `${centerBbox[1] - 0.000001},${centerBbox[0] - 0.000001},${
    centerBbox[3]
  },${centerBbox[2]}`
  // &TIME=${format(subDays(new Date(ICE_DRIFT_DATE), 180), 'yyyy-MM-dd')}/${format(new Date(ICE_DRIFT_DATE), 'yyyy-MM-dd')}/P1D
  return `${url}&TIME=${format(subDays(date, 45), 'yyyy-MM-dd')}/${format(addDays(date, 15), 'yyyy-MM-dd')}/P1D&bbox=${_bbox}`
}

const formatUrl = (item, viewparams, idToken, bounds, datetime, center, timeIso) => {
  const { type, url } = item

  switch (type) {
    case 'feathers':
      return url
    break
    case 'smallBox':
    return formatSmallBoxUrl(url, bounds, datetime, center, timeIso)
      break
    case 'bbox':
      return formatBboxUrl(url, bounds, datetime, center)
      break
    case 'global':
      return formatGlobalUrl(url, viewparams, idToken)
      break
    default:
      return formatDatetimeUrl(url, viewparams, idToken)
  }
}

export const updateTimestampEpic = (action$, store) =>
  action$
    .ofType(
      TIMESTAMP_UPDATE_REQUESTED,
      BOUNDS_CHANGED,
      LAYER_RENDER_TOGGLED,
      SET_ADVANCED_TIME_REQUESTED,
      SERVICE_CARD_CHANGED,
      TIME_SLIDER_VALUE_UPDATED,
    )
  .switchMap(({ layerName }) => {
      const state = store.getState()
      const {
        login: { authenticated, idToken },
        map: { bounds, toggleCenter },
        timeSlider: { value }
      } = state
      if (!authenticated) {
        return Observable.empty()
      }
      const viewparams = getViewparams(state)
      const datetime = getFutureDate(convertToDatetime(value))

    const datetimeArray = layerName
          ? datetimeUrls.filter(item => item.id === layerName)
          : datetimeUrls
      const fetchArray = datetimeArray.map(item => {
        // state.layer.times[item.id] && console.log({ [item.id]: state.layer.times[item.id] })
        const timeIso = state.layer.times[item.id]
        return Observable.zip(
          Observable.of(item.id),
          getShouldFetchDatetime(state, item.id, item.authId, item.secondary)
            ? Observable.from(
              fetch(
                formatUrl(
                  item,
                  viewparams,
                  idToken,
                  bounds,
                  datetime,
                  toggleCenter,
                  timeIso
                )
              )
            )
            : Observable.of(null),
          Observable.of(item.accessor),
          (id, response, accessor) => ({ id, response, accessor })
        )
      })
      return Observable.merge(...fetchArray)
    })
    .mergeMap(({ id, response, accessor }) =>
      Observable.zip(
        Observable.of(id),
        response && response.json
          ? Observable.from(response.json())
          : Observable.of(null),
        Observable.of(accessor),
        (id, json, accessor) => ({ id, json, accessor })
      )
              .catch(error => {

                console.log(error)
                return Observable.of({ type: 'ERROR' })
              })
    )
    .mergeMap(({ id, json, accessor }) => [
      timestampUpdateFulfilled(id, json, accessor),
      layerDefaultTimeUpdated(id, json, accessor)
    ])
    .catch(error => {
      console.log(error)
      return Observable.of({ type: 'ERROR' })
    })

const SET_NEW_TIME_REQUESTED = TimestampTypes.SET_NEW_TIME_REQUESTED
const SET_NEW_TIME_FULFILLED = TimestampTypes.SET_NEW_TIME_FULFILLED
const SET_ADVANCED_TIME_REQUESTED = TimestampTypes.SET_ADVANCED_TIME_REQUESTED
const LAYER_UPDATE_FULFILLED = LayerTypes.LAYER_UPDATE_FULFILLED
const TIME_SLIDER_VALUE_UPDATED = TimeSliderTypes.TIME_SLIDER_VALUE_UPDATED
const TIME_SLIDER_VALUE_DECREMENTED =
  TimeSliderTypes.TIME_SLIDER_VALUE_DECREMENTED
const TIME_SLIDER_VALUE_INCREMENTED =
  TimeSliderTypes.TIME_SLIDER_VALUE_INCREMENTED

const setNewTimeFulfilled = () => ({
  type: SET_NEW_TIME_FULFILLED
})

const layerTimeUpdated = (layerName, timestamp) => ({
  type: LAYER_TIME_UPDATED,
  layerName,
  timestamp
})

const layerUpdateFulfilled = datetime => ({
  type: LAYER_UPDATE_FULFILLED,
  datetime
})

const getRecentDatetime = (datetime, layerName, timestamps) => {
  const array = timestamps[layerName]
  const pastDatetimes = array.filter(item => item <= datetime)
  const length = pastDatetimes.length
  const mostRecentDatetime = length
    ? pastDatetimes[pastDatetimes.length - 1]
    : array[0]
  const mostRecentTimeIso = new Date(mostRecentDatetime).getTime()
  return layerTimeUpdated(layerName, mostRecentTimeIso)
}

export const setNewTimeEpic = (action$, store) =>
  action$
    .ofType(
      SET_NEW_TIME_REQUESTED,
      TIME_SLIDER_VALUE_UPDATED,
      TIME_SLIDER_VALUE_DECREMENTED,
      TIME_SLIDER_VALUE_INCREMENTED,
      TIME_SLIDER_SEASON_UPDATED
    )
  .mergeMap(() => {
      const state = store.getState()
      const { value } = state.timeSlider
      const { timestamps } = state.timestamp
      const datetime = value ? new Date(value).toISOString() : null

      const layerTimeUpdates_ = Object.keys(timestamps)
        .filter(key => timestamps[key].length > 0)
        .map(key => getRecentDatetime(datetime, key, timestamps))

      return [
        ...layerTimeUpdates_,
        setNewTimeFulfilled(),
        layerUpdateFulfilled(value)
      ]
    })
    .catch(error => {
      console.log(error)
      return Observable.of(null)
    })

export const setTimeSliderCenter = (action$, store) =>
  action$
  .ofType(
    TIME_SLIDER_VALUE_DECREMENTED,
    TIME_SLIDER_VALUE_INCREMENTED,
  )
  .mergeMap(() => {
    const state = store.getState()
    const { value } = state.timeSlider
    const { timestamps } = state.timestamp
    const datetime = value ? new Date(value).toISOString() : null

    const layerTimeUpdates_ = Object.keys(timestamps)
          .filter(key => timestamps[key].length > 0)
          .map(key => getRecentDatetime(datetime, key, timestamps))

    return [
      ...layerTimeUpdates_,
      setNewTimeFulfilled(),
      layerUpdateFulfilled(value)
    ]
  })
  .catch(error => {
    console.log(error)
    return Observable.of(null)
  })


export const setAdvancedTimeEpic = (action$, store) =>
  action$
  .ofType(SET_ADVANCED_TIME_REQUESTED)
  .mergeMap(({ layerName, timestamp }) => {
    // const epochTime = convertDateToUTC(new Date(timestamp)).getTime()
    // const epochTime = createDateAsUTC(new Date(timestamp)).getTime()
    const epochTime = new Date(timestamp).getTime()

    return [
      layerTimeUpdated(layerName, epochTime),
      setNewTimeFulfilled()]
    })
    .catch(error => {
      console.log(error)
      return { type: 'ERROR' }
    })

const timeSliderMarksUpdated = ({ marks, value }) => ({
  type: TIME_SLIDER_MARKS_UPDATED,
  marks,
  value
})

export const updateTimestampValueEpic = (action$, store) =>
  action$
  .ofType(TIMESTAMP_UPDATE_FULFILLED)
  .mergeMap(() => {
    const state = store.getState()
    const marks = getGeneratedMarks(state)
    const value = state.timeSlider.value
    return [timeSliderMarksUpdated({ marks, value })]
    })
    .catch(error => {
      console.log(error)
      return { type: 'ERROR' }
    })

const timeSliderSeasonUpdated = ({ marks, value }) => ({
  type: TIME_SLIDER_SEASON_UPDATED,
  marks,
  value
})

export const updateSeasonEpic = (action$, store) =>
  action$
  .ofType(SEASON_INCREMENTED, SEASON_DECREMENTED)
  .mergeMap(() => {
    const state = store.getState()
    const marks = getGeneratedMarks(state)
    const value = state.timeSlider.value
    return [timeSliderSeasonUpdated({ marks, value })]
  })
  .catch(error => {
    console.log(error)
    return { type: 'ERROR' }
  })

export const updateMinMaxTimeEpic = (action$, store) =>
  action$
  .ofType(SERVICE_CARD_CHANGED)
  .mergeMap(action => {
    return [{ type: 'ERROR' }]
  })

export const syncTimeEpic = (action$, store) =>
action$
    .ofType(SERVICE_CARD_CHANGED)
    .mergeMap(action => {
        return [{ type: 'ERROR' }]
    })



// WEBPACK FOOTER //
// ./src/redux/timestampEpic.js